import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Search } from 'lucide-react';
import { HelpGuidesLayout } from './HelpGuidesLayout';
import { useHelpGuides } from './useHelpGuides';
import { formatGuideDate } from './utils';

export const HelpGuidesIndex: React.FC = () => {
  const {
    authLoading,
    isAuthenticated,
    isLoading,
    guides,
    categories,
    selectedCategoryId,
    setSelectedCategoryId,
    search,
    setSearch,
    error,
  } = useHelpGuides();

  if (authLoading || isLoading) {
    return (
      <div className="page-container flex items-center justify-center">
        <div className="text-center animate-fade-in">
          <div className="w-12 h-12 mx-auto mb-4 spinner" />
          <p className="text-gray-600 font-medium">Loading Help Guides...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return null;

  return (
    <HelpGuidesLayout
      categories={categories}
      selectedCategoryId={selectedCategoryId}
      onSelectCategory={setSelectedCategoryId}
      error={error}
    >
      <div className="relative mb-6">
        <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
          type="search"
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search guides..."
          className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
        />
      </div>

      {guides.length === 0 ? (
        <div className="text-center py-16 text-gray-500">
          <BookOpen className="mx-auto mb-3 text-gray-300" size={40} />
          <p>No guides found.</p>
          <p className="mt-2 text-sm text-gray-400">More guides coming soon.</p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {guides.map(guide => (
              <Link
                key={guide.id}
                to={`/help/${guide.slug}`}
                className="flex items-start gap-3 p-5 bg-white border border-gray-200 rounded-xl hover:border-primary-300 hover:shadow-sm transition-all"
              >
                <div className="w-10 h-10 rounded-lg bg-teal-50 flex items-center justify-center shrink-0">
                  <BookOpen size={20} className="text-teal-700" />
                </div>
                <div className="min-w-0">
                  <h2 className="font-semibold text-gray-900 truncate">{guide.title}</h2>
                  <p className="text-sm text-gray-500 mt-1">
                    Updated {formatGuideDate(guide.updatedAt)}
                  </p>
                </div>
              </Link>
            ))}
          </div>
          <p className="mt-8 text-center text-sm text-gray-400">More guides coming soon.</p>
        </>
      )}
    </HelpGuidesLayout>
  );
};
